import {
    USER_STATIONS_FETCHED,
    USER_SELECTED_STATION,
    USER_FILTERED_STATION,
    CLEAR_STATION_SELECTION
} from '../../actions/types';

let defaultState={
    selectedStation:0
};

export default function(state = defaultState, action){
    switch (action.type){
        case USER_STATIONS_FETCHED:
            return {list:action.payload};
        case USER_SELECTED_STATION:
            return {...state, selectedStation: action.payload};
        case USER_FILTERED_STATION:
            return {...state, filteredStation: action.payload};
        case CLEAR_STATION_SELECTION:
            return {...state, selectedStation: 0};
        default:
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Stations/index.js